import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=72a89b4b&scoped=true&lang=pug"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"
import style0 from "./Row.vue?vue&type=style&index=0&id=72a89b4b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a89b4b",
  null
  
)

export default component.exports